module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "choose-plan"
  }, [_c('li', {
    class: {
      active: _vm.changePlan == 'b2cSodre'
    },
    on: {
      "click": function($event) {
        _vm.changePlan = 'b2cSodre'
      }
    }
  }, [_vm._v("\n              Para Você\n            ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.changePlan == 'b2bSodre'
    },
    on: {
      "click": function($event) {
        _vm.changePlan = 'b2bSodre'
      }
    }
  }, [_vm._v("\n              Para Sua Empresa\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "bold margin-b0 margin-t30"
  }, [_vm._v("PLANO")]), _vm._v(" "), (_vm.changePlan == 'b2cSodre') ? _c('p', [_vm._v("Ideal para você :")]) : _c('p', [_vm._v("Indispensável à sua empresa :")]), _vm._v(" "), (_vm.changePlan == 'b2cSodre') ? _c('b2cSodre', {
    staticClass: "margin-t20",
    attrs: {
      "type": "adhesion"
    }
  }) : _c('b2bSodre', {
    staticClass: "margin-t20",
    attrs: {
      "type": "adhesion"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-2754a0b7!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/services-sodre.vue
// module id = 2072
// module chunks = 1